import { placeholderPhoto } from '../lib/format.js';

/**
 * Restaurant photography.
 *
 * Prefers a live Google Places photo when the caller has one, and otherwise
 * falls back to the deterministic placeholder tied to the restaurant's
 * `imageSeed`. Real photography would replace `placeholderPhoto`.
 *
 * @param {object} props
 * @param {import('../lib/types.js').Restaurant} props.restaurant
 * @param {string} [props.src]  Live photo URL, if one has loaded.
 * @param {object} [props.style]
 */
export function RestaurantImage({ restaurant, src, style }) {
  const fallback = placeholderPhoto(restaurant.imageSeed);

  return (
    <img
      src={src || fallback}
      alt={restaurant.name}
      draggable="false"
      loading="lazy"
      onError={(event) => {
        // Guard against an infinite loop if the fallback itself 404s.
        if (event.currentTarget.src === fallback) return;
        event.currentTarget.src = fallback;
      }}
      style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', ...style }}
    />
  );
}
